import { useRouter } from "next/router";
import Container from "./Container";
import Image from "next/image";

export default function Footer() {
  const router = useRouter();
  const commonLinks = [
    { label: "Careers", url: "https://careers.qoncertapp.com" },
    { label: "Contact", url: " https://help.qoncertapp.com/contact" },
    { label: "Help", url: "https://help.qoncertapp.com" },
    { label: "Venues", url: "https://venues.qoncertapp.com" },
    { label: "Sponsors", url: "https://sponsors.qoncertapp.com" },
    { label: "Management", url: "https://management.qoncertapp.com" },
    {
      label: "Privacy Policy",
      url: "https://help.qoncertapp.com/privacy-policy",
    },
    { label: "Terms of Service", url: "https://help.qoncertapp.com/terms" },
    {
      label: "Purchase Terms",
      url: "https://help.qoncertapp.com/purchase-policy",
    },
    { label: "Awards", url: "https://awards.qoncertapp.com " },
    { label: "Rough Draft", url: "https://roughdraft.qoncertapp.com " },
  ];


  const navigateLink = (label) => {
    const allLinks = [...commonLinks];
    const foundLink = allLinks.find((link) => link.label == label);

    if (foundLink && foundLink.url && foundLink.url != "TO_BE_ADDED_LATER") {
      // window.open(foundLink.url, "_self");
      router.push(foundLink.url);
    } else {
      console.warn(`Link for "${label}" is not available or not ready.`);
    }
  };

  const goHome = () => {
    if (router.pathname !== "/") {
      router.push("/");
    }
  };

  return (
    <div>
      <footer
        id="footer"
        className="lg:pt-[135px] mt-[50px] relative z-[2] border-t border-[#FFFFFF1A] lg:border-transparent pt-[20px] "
      >
        <Container className=" px-6 ">
          <div className="hidden md:block">
            <div className="grid  grid-cols-2 md:grid-cols-6  gap-y-5  justify-center md:justify-between">
              <div className="footer-logo flex justify-center md:justify-start mb-4">
                <div>
                  <img
                    onClick={goHome}
                    className="w-[130px] cursor-pointer h-[44px]"
                    src={"/assets/logo.webp"}
                    alt=""
                  />
                  <div className="mt-6 hidden md:flex gap-3">
                    <div
                      onClick={() =>
                        window.open(
                          "https://apps.apple.com/in/app/qoncert-live-shows/id1537042846",
                          "_blank"
                        )
                      }
                    >
                      <img src="/assets/footerAppStore.png" alt="" />
                    </div>
                    <div
                      className=" cursor-pointer "
                      onClick={() =>
                        window.open(
                          "https://play.google.com/store/apps/details?id=com.qoncertapp.artist",
                          "_blank"
                        )
                      }
                    >
                      <img src="/assets/FooterGpay.png" alt="" />
                    </div>
                  </div>
                </div>
              </div>
              <div className="md:block hidden"></div>
              <div className="md:block hidden"></div>
              <div className="footer-items text-center md:text-start">
                <h2 className=" font-[600] text-[20px] ">Qoncert</h2>
                <div className="mt-3 ">
                  <p
                    onClick={() => router.push("/about")}
                    className="my-5 border-b hover:border-white transition-all border-transparent w-fit cursor-pointer "
                  >
                    About
                  </p>
                  <p
                    onClick={() => navigateLink("Careers")}
                    className="my-5 border-b hover:border-white transition-all border-transparent w-fit cursor-pointer "
                  >
                    Careers
                  </p>
                  <p
                    onClick={() => navigateLink("Awards")}
                    className="my-5 border-b hover:border-white transition-all border-transparent w-fit cursor-pointer "
                  >
                    Awards
                  </p>
                </div>
              </div>
              <div className="footer-items text-center md:text-start">
                <h2 className=" font-[600] text-[20px]  ">Help</h2>
                <div className="mt-3 ">
                  <p
                    onClick={() => navigateLink("Contact")}
                    className="my-5 border-b hover:border-white border-transparent transition-all w-fit cursor-pointer "
                  >
                    Contact Us
                  </p>
                  <p
                    onClick={() => navigateLink("Help")}
                    className="my-5 border-b hover:border-white border-transparent transition-all w-fit cursor-pointer "
                  >
                    Help Center
                  </p>
                  <p
                    onClick={() => navigateLink("Rough Draft")}
                    className="my-5 border-b hover:border-white border-transparent transition-all w-fit cursor-pointer "
                  >
                    Rough Draft
                  </p>
                </div>
              </div>
              <div className="footer-items text-center md:text-start me-">
                <h2 className=" font-[600] text-[20px]  ">Partners</h2>
                <div className="mt-3 ">
                  <p
                    onClick={() => navigateLink("Venues")}
                    className="my-5 border-b hover:border-white border-transparent transition-all w-fit cursor-pointer "
                  >
                    Venues
                  </p>
                  <p
                    onClick={() => navigateLink("Sponsors")}
                    className="my-5 border-b hover:border-white border-transparent transition-all w-fit cursor-pointer "
                  >
                    Sponsors
                  </p>
                  <p
                    onClick={() => navigateLink("Management")}
                    className="my-5 border-b hover:border-white border-transparent transition-all w-fit cursor-pointer "
                  >
                    Management
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="md:hidden">
            <div className="flex w-full justify-center branding gap-6">
              <div
                className="w-[100px] cursor-pointer"
                onClick={() =>
                  window.open(
                    "https://apps.apple.com/us/app/qoncert-live-shows/id1537042846",
                    "_blank"
                  )
                }
              >
                <Image
                  src="/assets/appstorebadge.png"
                  alt="Apple Store"
                  width={100}
                  height={32}
                  quality={85}
                  priority // Optional: since this is above the fold
                />
              </div>
              <div
                className="w-[100px] cursor-pointer"
                onClick={() =>
                  window.open(
                    "https://play.google.com/store/apps/details?id=com.qoncertapp.artist",
                    "_blank"
                  )
                }
              >
                <Image
                  src="/assets/googleplaybadge.png"
                  alt="Google Play"
                  width={100}
                  height={32}
                  quality={85}
                  priority
                />
              </div>
            </div>
          </div>
          <div className="pt-6 mb:pt-0">
            <div className="flex justify-center md:justify-start md:mt-0 gap-5">
              <a
                className=" hover:scale-105 transition-all "
                href="https://instagram.com/qoncertapp"
                target="_blank"
                aria-label="Instagram"
              >
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7.2 0H16.8C20.7765 0 24 3.22355 24 7.2V16.8C24 20.7765 20.7765 24 16.8 24H7.2C3.22355 24 0 20.7765 0 16.8V7.2C0 3.22355 3.22355 0 7.2 0ZM19.2 3.6C19.8 3.6 20.4 4.2 20.4 4.8C20.4 5.4 19.8 6 19.2 6C18.6 6 18 5.4 18 4.8C18 4.2 18.6 3.6 19.2 3.6ZM18 12C18 8.691 15.309 6 12 6C8.691 6 6 8.691 6 12C6 15.309 8.691 18 12 18C15.309 18 18 15.309 18 12ZM12 8.4C10.0118 8.4 8.4 10.0118 8.4 12C8.4 13.9882 10.0118 15.6 12 15.6C13.9882 15.6 15.6 13.9882 15.6 12C15.6 10.0118 13.9882 8.4 12 8.4Z"
                    fill="white"
                  />
                </svg>
              </a>
              <a
                className=" hover:scale-105 transition-all "
                href="https://facebook.com/qoncertapp"
                target="_blank"
                aria-label="Facebook"
              >
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M21.6 0H2.4C1.07452 0 0 1.07452 0 2.4V21.6C0 22.9255 1.07452 24 2.4 24H12V14.9647H8.4V11.5765H12V9.75699C12 6.31228 13.7876 4.8 16.71 4.8C18.082 4.8 18.8203 4.89771 19.179 4.94517L19.2 4.94795V8.18824H17.2068C15.9664 8.18824 15.6 8.82974 15.6 10.1286V11.5765H19.1689L18.6755 14.9647H15.6V24H21.6C22.9255 24 24 22.9255 24 21.6V2.4C24 1.07452 22.9255 0 21.6 0Z"
                    fill="white"
                  />
                </svg>
              </a>
              <a
                className=" hover:scale-105 transition-all "
                href="https://twitter.com/qoncertapp"
                target="_blank"
                aria-label="Twitter"
              >
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M21.6 0H2.4C1.07452 0 0 1.07452 0 2.4V21.6C0 22.9255 1.07452 24 2.4 24H21.6C22.9255 24 24 22.9255 24 21.6V2.4C24 1.07452 22.9255 0 21.6 0ZM18.4203 7.48724C19.1174 7.40665 19.7817 7.22797 20.4 6.96246C19.938 7.6303 19.3533 8.21692 18.6794 8.68735C18.6858 8.83041 18.689 8.9741 18.689 9.11842C18.689 13.5222 15.2232 18.6 8.8834 18.6C6.93661 18.6 5.12551 18.0484 3.6 17.1031C3.87008 17.1344 4.14469 17.15 4.42252 17.15C6.03784 17.15 7.52394 16.6171 8.70313 15.7231C7.19506 15.6962 5.92219 14.7323 5.48347 13.4085C5.69346 13.4466 5.90991 13.4678 6.13153 13.4678C6.4462 13.4678 6.75117 13.4272 7.03999 13.351C5.46279 13.0455 4.2752 11.6986 4.2752 10.0836V10.0418C4.73977 10.291 5.27154 10.441 5.83625 10.4585C4.91164 9.86122 4.30363 8.84103 4.30363 7.68528C4.30363 7.07366 4.47357 6.50141 4.76949 6.00912C6.4701 8.02576 9.00939 9.35269 11.8737 9.49138C11.8155 9.24836 11.7845 8.99347 11.7845 8.73233C11.7845 6.89249 13.3275 5.4 15.231 5.4C16.2221 5.4 17.1177 5.80483 17.7463 6.45268C18.532 6.30274 19.2699 6.02536 19.9354 5.64365C19.6783 6.42206 19.1323 7.07491 18.4203 7.48724Z"
                    fill="white"
                  />
                </svg>
              </a>
            </div>
            <div className="pt-6 md:hidden">
              <div className="flex text-base flex-wrap gap-2 justify-center px-6">
                <div onClick={() => router.push("/about")} className=" mr-6">
                  About
                </div>
                <div onClick={() => navigateLink("Careers")} className=" mr-6">
                  Careers
                </div>
                <div onClick={() => navigateLink("Awards")} className=" mr-6">
                  Awards
                </div>
                <div onClick={() => navigateLink("Help")} className=" mr-4">
                  Help
                </div>
                <div onClick={() => navigateLink("Contact")} className=" mr-3">
                  Contact
                </div>
                <div onClick={() => navigateLink("Venues")} className=" mr-2">
                  Venues
                </div>
                <div onClick={() => navigateLink("Sponsors")} className=" mr-">
                  Sponsors
                </div>
                <div onClick={() => navigateLink("Management")} className="mr-5">
                  Management
                </div>
                <div onClick={() => navigateLink("Rough Draft")} className="">
                  Rough Draft
                </div>
              </div>
            </div>
            <div className="lg:mt-11 mt-3 ">
              <div className="pt-6 border-t flex  gap-6 flex-col md:flex-row text-center justify-between border-[#1E1E1E]">
                <div className="grid grid-cols-3 text-[12px] lg:text-sm gap-6  text-[#FFFFFF] iems-center">
                  <p
                    onClick={() => navigateLink("Privacy Policy")}
                    className=" cursor-pointer border-b border-transparent hover:border-white transition-all "
                  >
                    Privacy Policy
                  </p>
                  <p
                    onClick={() => navigateLink("Terms of Service")}
                    className=" cursor-pointer border-b border-transparent hover:border-white transition-all "
                  >
                    Terms of Service
                  </p>
                  <p
                    onClick={() => navigateLink("Purchase Terms")}
                    className=" cursor-pointer border-b border-transparent hover:border-white transition-all "
                  >
                    Purchase Terms
                  </p>
                </div>
                <div className="lg:text-sm text-[#8E8E93] lg:text-white pb-[16px]  text-[12px] ">
                  <p>Copyright © 2025 Qoncert, Inc.</p>
                </div>
              </div>
            </div>
          </div>
        </Container>
      </footer>
    </div>
  );
}
